import json from './sprite.js';

export default {
    handle: 'SP_SPT1-Puppy',
    label: 'es_SPT1-Puppy_234684231',
    json,
};
